@if (refreshType) {
    <p-button
            label="Aktualisieren"
            [icon]="(refreshType > 1 && showIcon) ? 'fa-regular fa-timer' : ''"
            (click)="handleRefresh()"
            [disabled]="disableButton"
    ></p-button>
}
